import { render, staticRenderFns } from "./SelfSignupExpired.vue?vue&type=template&id=2e9b4fe8&scoped=true&"
import script from "./SelfSignupExpired.vue?vue&type=script&lang=js&"
export * from "./SelfSignupExpired.vue?vue&type=script&lang=js&"
import style0 from "./SelfSignupExpired.vue?vue&type=style&index=0&id=2e9b4fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9b4fe8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
